/**
 * This file is Auth provider for AWS Cognito inspired by `AuthZero/Auth.web.js`.
 */

import React from 'react';
import { connect } from 'react-redux';

import { Auth } from 'aws-amplify';
import login from 'modules/general/shared/action/login';
import logout from 'modules/general/shared/action/logout';

export const CognitoAuthContext = React.createContext({});

const mapStateToProps = state => ({
  authState: state.general.auth,
});

const mapDispatchToProps = dispatch => ({
  login: authResult => dispatch(login(authResult)),
  logout: () => dispatch(logout()),
});

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
);

@connectToRedux
export default class CognitoAuthProvider extends React.Component {
  state = {
    user: null,
  };

  isAuthenticated = !!this.state.user;

  componentDidMount() {
    Auth.currentSession()
      .then(res => {
        if (res) {
          this.applyUser(res);
        }
      })
      .catch(() => {
        this.clearSession();
      });
  }

  getToken = async () => {
    const currentSession = await Auth.currentSession();
    return currentSession.getIdToken().getJwtToken();
  };

  applyUser = cognitoUser => {
    const user = cognitoUser.getIdToken().decodePayload();

    const idToken = cognitoUser.getIdToken().getJwtToken();

    if (!user) return;

    const { 'https://tvlk/permissions': permissions } = user;

    const userPermissions = JSON.parse(permissions);

    // Props login actually accept token expiration time
    // But we don't pass it since `aws-amplify` already handle it
    this.props.login({
      accessToken: idToken,
      idToken,
      userPermissions,
    });
  };

  render() {
    return (
      <CognitoAuthContext.Provider
        value={{
          user: this.state.user,
          getToken: this.getToken,
          applyUser: this.applyUser,
          isAuthenticated: this.isAuthenticated,
        }}
      >
        {this.props.children}
      </CognitoAuthContext.Provider>
    );
  }
}
